import { customerApi } from "../../utils/apiConfig";

export const equipmentPlanInsert = (payload) => {
  return customerApi.post("/equipmentPlanInsert", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const getPersonels = () => {
  return customerApi.get("/getPersonelForEquipmentPlan", {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const equipmentPlanUpdate = (payload) => {
  return customerApi.post("/equipmentPlanUpdate", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const equipmentPlanDelete = (payload) => {
  return customerApi.post("/equipmentPlanDelete", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const equipmentPlanList = (payload) => {
  return customerApi.post("/equipmentPlanList", payload, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};